import { ActivityType, type Notification } from '~/types/activity.types'

export const getActivityIcon = (type: ActivityType) => {
  switch (type) {
    case ActivityType.CommentCreated:
    case ActivityType.CommentReplied:
    case ActivityType.Mention:
      return 'pi pi-comment text-blue-500'
    case ActivityType.IssueOpened:
      return 'pi pi-exclamation-circle text-red-500'
    case ActivityType.IssueClosed:
      return 'pi pi-check-circle text-green-500'
    case ActivityType.DocStagingStatusChanged:
    case ActivityType.DocLiveStatusChanged:
      return 'pi pi-file-edit text-orange-500'
    case ActivityType.DocPicAssigned:
      return 'pi pi-user-plus text-purple-500'
    case ActivityType.DocFileUploaded:
      return 'pi pi-upload text-blue-400'
    case ActivityType.DocOfficiated:
      return 'pi pi-verified text-green-600'
    case ActivityType.DocArchived:
      return 'pi pi-trash text-red-500'
    case ActivityType.ControlStatusChanged:
      return 'pi pi-info-circle text-cyan-500'
    case ActivityType.ControlDocMapped:
      return 'pi pi-link text-indigo-500'
    case ActivityType.ControlDocUnmapped:
      return 'pi pi-link-slash text-gray-500'
    default:
      return 'pi pi-bell text-gray-400'
  }
}

export const getActivityText = (type: ActivityType, actorName: string) => {
  switch (type) {
    case ActivityType.CommentCreated:
      return `${actorName} commented`
    case ActivityType.CommentReplied:
      return `${actorName} replied to a comment`
    case ActivityType.Mention:
      return `${actorName} mentioned you`
    case ActivityType.IssueOpened:
      return `${actorName} opened an issue`
    case ActivityType.IssueClosed:
      return `${actorName} resolved an issue`
    case ActivityType.DocStagingStatusChanged:
      return `${actorName} updated document status`
    case ActivityType.DocLiveStatusChanged:
      return `${actorName} changed document live status`
    case ActivityType.DocPicAssigned:
      return `${actorName} reassigned a document`
    case ActivityType.DocFileUploaded:
      return `${actorName} uploaded a new file`
    case ActivityType.DocOfficiated:
      return `${actorName} officiated a document`
    case ActivityType.DocArchived:
      return `${actorName} archived a document`
    case ActivityType.ControlStatusChanged:
      return `${actorName} updated control status`
    case ActivityType.ControlDocMapped:
      return `${actorName} mapped a document to a control`
    case ActivityType.ControlDocUnmapped:
      return `${actorName} unmapped a document from a control`
    default:
      return actorName
  }
}
export const getActivityLink = (notif: Notification) => {
  const { activityType, docId, controlId } = notif

  // Is it a comment or issue or mention?
  const isComment = [
    ActivityType.CommentCreated,
    ActivityType.CommentReplied,
    ActivityType.Mention,
    ActivityType.IssueOpened,
    ActivityType.IssueClosed,
  ].includes(activityType)

  if (docId && controlId) {
    // Control-Document Linkage
    return `/controls?controlId=${controlId}&documentId=${docId}${isComment ? '&showComments=true' : ''}`
  }

  if (controlId) {
    // Control only
    return `/controls?controlId=${controlId}${isComment ? '&showComments=true' : ''}`
  }

  if (docId) {
    // Document only
    return `/documents?documentId=${docId}${isComment ? '&showComments=true' : ''}`
  }

  return '#'
}
